/**
 * Request bodies, as the API accepts them.
 *
 * `entities.ts` describes what comes *out* of the API; this file describes what
 * goes *in*. They are deliberately separate types rather than one type with
 * optional fields: a volunteer read model carries `volunteer_id`, `status` and
 * `created_at`, and a caller must never be able to set any of them (§9.14 is the
 * same argument applied to attendance).
 *
 * Conventions:
 *   - A field that is absent means "not supplied". A field explicitly `null`
 *     means "clear this value". Both are legal on a PATCH; only the first is
 *     meaningful on a POST.
 *   - Multi-value pick-lists (`languages`, `areas_of_interest`) are a
 *     comma-separated string of `reference_values` codes, matching the column and
 *     the read model. The UI joins and splits; the wire format never disagrees
 *     with what `psql` shows.
 */
// ---------------------------------------------------------------------------
// Multi-value pick-list helpers
// ---------------------------------------------------------------------------
/** `['ENGLISH','HINDI']` -> `'ENGLISH,HINDI'`. Empty list -> `null`. */
export function joinCodes(codes) {
    const cleaned = codes.map((code) => code.trim()).filter(Boolean);
    return cleaned.length === 0 ? null : cleaned.join(',');
}
/** `'ENGLISH,HINDI'` -> `['ENGLISH','HINDI']`. Null or blank -> `[]`. */
export function splitCodes(value) {
    if (!value)
        return [];
    return value
        .split(',')
        .map((code) => code.trim())
        .filter(Boolean);
}
//# sourceMappingURL=requests.js.map